import React, { Component } from 'react';
import gql from 'graphql-tag';
import { Elastic, TimelineLite } from 'gsap/all';
import PropTypes from 'prop-types';
import { compose, graphql } from 'react-apollo';
import GameBalanceReloadDisplay from 'components/GameBalanceReloadDisplay';
import GameBalanceWheel from 'components/GameBalanceWheel';
//import ReCAPTCHA from 'react-google-recaptcha';
import { dispatchSpinEnd } from 'utils/gameEvents';
import { errorShape } from 'utils/shapes';
import ButtonSpinButton from './assets/Wheel-Center-Spin-Button.png';
import './GameBalanceReloader.css';

class GameBalanceReloader extends Component {
  constructor(props) {
    super(props);

    this.START_DELAY_MS = 4000; // set this too low and it comes up during spin.  set this too high and user might be able to start another spin before displayed.
    this.RESULT_DISPLAY_MS = 4000;
    this.RESULT_FADE_MS = 1000;

    this.siteKey = process.env.REACT_APP_GOOGLE_RECAPTCHA_SITE_KEY;
    this.captchaTokenReceived = this.captchaTokenReceived.bind(this);

    this.handleStateChange = this.handleStateChange.bind(this);
    this.beginSpinAnimation = this.beginSpinAnimation.bind(this);

    this.unsubscribeFromNewData = () => {};

    this.state = {
      stopIndex: null,
      winAmount: null,
      pending: false,
      fadeIn: false,
      wheelLoading: true,
      beginSpin: false
    };

    this.timeline = new TimelineLite({ paused: true });
    this.background = null;
    this.wheel = null;
    this.title = null;
    this.header = null;
    this.text = null;
    this.button = null;

    this.resultTimeline = new TimelineLite({ paused: true });
  }

  componentDidMount() {
    this.unsubscribeFromNewData = this.props.subscribeToNewData();
  }

  shouldShowReload(props) {
    return (
      props &&
      props.data &&
      !props.data.loading &&
      props.data.balanceReloadNeeded.needed
    );
  }

  componentWillUnmount() {
    this.unsubscribeFromNewData();
    this.unsubscribeFromNewData = () => {};
  }

  handleStateChange(state) {
    if (state === 'RESULTS') {
      this.setState({
        winAmount:
          this.props.wedgeData.gameBalanceReloadAmounts[this.state.stopIndex]
            .amount
      });

      this.confirmStop();
      this.props.reloadCompletedCallback &&
        this.props.reloadCompletedCallback();
    }
  }

  beginSpinAnimation() {
    this.setState({ beginSpin: true });
    this.spin();
    this.getStop();
  }

  confirmStop() {
    // tell the server we stopped so it can finalize the spin and add balance.
    this.props.confirmStopWedge().then(resp => {
      if (resp && resp.data && resp.data.confirmGameBalanceReload) {
      } else {
        // failure confirming spin result
        console.error('spin result confirmation failure');
      }
    });
  }

  captchaTokenReceived(token) {
    this.getStop(token);
  }

  getStop(captchaToken) {
    this.props.selectStopWedge(captchaToken).then(resp => {
      if (resp && resp.data) {
        this.setState({ stopIndex: resp.data.computeGameBalanceReloadIndex });
      } else {
        // problem getting stop wedge
      }
    });
  }

  playFadeIn() {
    this.timeline.kill().clear().pause(0);
    this.timeline
      .to(this.background, 0.75, { opacity: 1, top: '1.78571rem' })
      .to(this.wheel, 1, { scale: 1, ease: Elastic.easeOut.config(1, 1) }, '.3')
      .to(
        this.title,
        1,
        { scale: 1, ease: Elastic.easeOut.config(1, 1) },
        '.55'
      )
      .to(
        this.header,
        1,
        { scale: 1, ease: Elastic.easeOut.config(1, 1) },
        '.7'
      )
      .to(
        this.text,
        1,
        { scale: 1, opacity: 1, ease: Elastic.easeOut.config(1, 1) },
        '.85'
      )
      .to(
        this.button,
        1,
        { scale: 1, opacity: 1, ease: Elastic.easeOut.config(1, 1) },
        '1'
      )
      .play();
  }

  playFadeOut() {
    this.timeline.kill().clear().pause(0);
    this.timeline
      .to(
        this.button,
        1,
        {
          scale: 0,
          ease: Elastic.easeIn.config(1, 1),
          onComplete: () => {
            this.setState({ fadeIn: false });
          }
        },
        '1'
      )
      .to(
        this.header,
        1,
        { scale: 0, ease: Elastic.easeIn.config(1, 1) },
        '1.3'
      )
      .to(this.text, 1, { scale: 0, ease: Elastic.easeIn.config(1, 1) }, '1.3')
      .to(
        this.title,
        1,
        { scale: 0, ease: Elastic.easeIn.config(1, 1) },
        '1.55'
      )
      .to(this.wheel, 1, { scale: 0, ease: Elastic.easeIn.config(1, 1) }, '1.7')
      .to(
        this.background,
        1,
        {
          opacity: 0,
          top: '7rem',
          onComplete: () => {
            this.setState({ winAmount: null });
          }
        },
        '2'
      )
      .play();
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      this.shouldShowReload(this.props) &&
      !this.shouldShowReload(prevProps)
    ) {
      // showing reload
      clearTimeout(this.timeoutId);
      this.timeoutId = setTimeout(() => {
        this.setState({
          pending: false,
          fadeIn: true,
          stopIndex: null
        });
        this.playFadeIn();
      }, this.START_DELAY_MS);
      this.setState({
        pending: true
      });
    } else if (
      !this.shouldShowReload(this.props) &&
      this.shouldShowReload(prevProps)
    ) {
      // hiding reload
      clearTimeout(this.timeoutId);
      this.timeoutId = setTimeout(() => {
        dispatchSpinEnd(); // trigger balance meter update
        this.playFadeOut();
      }, this.RESULT_DISPLAY_MS);
      this.setState({
        pending: false
      });
    }
  }

  shouldRender() {
    return this.state.fadeIn || this.state.winAmount;
  }

  renderReloader() {
    if (this.shouldRender())
      return (
        <div className="game-balance-reload">
          <div
            className="game-balance-reload-content"
            ref={div => (this.background = div)}
          >
            <GameBalanceReloadDisplay
              startSpin={() => {
                this.spin();
                //this.captcha.execute();
                this.getStop();
              }}
              winAmount={this.state.winAmount}
              setTitle={ref => (this.title = ref)}
              setHeader={ref => (this.header = ref)}
              setText={ref => (this.text = ref)}
              setButtonArea={ref => (this.button = ref)}
              beginSpin={this.state.beginSpin}
            />
            <div className="body-right">
              <GameBalanceWheel
                loadingCompleteCallback={() => {
                  this.setState({ wheelLoading: false });
                }}
                registerSpinCallback={spinCallback => {
                  this.spin = spinCallback;
                }}
                beginSpinAnimation={this.beginSpinAnimation}
                stateChangeHandler={this.handleStateChange}
                wedgeData={this.props.wedgeData}
                stopIndex={this.state.stopIndex}
                refSetter={ref => (this.wheel = ref)}
              />
              <button
                type="button"
                className="balance-win-wheel-spin-button"
                onClick={this.beginSpinAnimation}
              >
                <img src={ButtonSpinButton} alt="Start spin" />
              </button>
              {/*<ReCAPTCHA
                  ref={elem => {
                    this.captcha = elem;
                  }}
                  sitekey={this.siteKey}
                  onChange={token => {
                    this.captchaTokenReceived(token);
                    this.captcha.reset();
                  }}
                  theme="dark"
                  onExpired={param => {
                    console.log('captcha expired:' + param);
                  }}
                  size="invisible"
                  badge="inline"
                />*/}
            </div>
            <div className="game-balance-reload-mobile-footer"></div>
          </div>
        </div>
      );
    else return null;
  }

  render() {
    return (
      <div
        className={
          'game-balance-reload-viewport' +
          (!this.state.wheelLoading && this.state.fadeIn ? ' fade-in' : '') +
          (this.state.pending ? ' pending' : '')
        }
      >
        {this.renderReloader()}
      </div>
    );
  }
}

const WheelWedgesQuery = gql`
  query GetWheelWedges {
    gameBalanceReloadAmounts {
      amount
    }
  }
`;

const WheelWedgesOption = {
  name: 'wedgeData',
  options: {
    fetchPolicy: 'network-only'
  }
};

const SelectStopWedgeMutation = gql`
  mutation SelectStopWedge($input: ComputeReloadIndexInput!) {
    computeGameBalanceReloadIndex(input: $input)
  }
`;

const SelectStopWedgeOption = {
  props({ mutate }) {
    return {
      selectStopWedge: captchaToken => {
        return mutate({
          variables: {
            input: {
              //captchaData: captchaToken,
              //mobileKey: 'key'
            }
          }
        });
      }
    };
  }
};

const ConfirmStopWedgeMutation = gql`
  mutation ConfirmStopWedge {
    confirmGameBalanceReload
  }
`;

const ConfirmStopWedgeOption = {
  props({ mutate }) {
    return {
      confirmStopWedge: () => {
        return mutate();
      }
    };
  }
};

const QUERY_BALANCE_RELOAD_NEEDED = gql`
  query {
    balanceReloadNeeded {
      needed
    }
  }
`;

const SUBSCRIPTION_BALANCE_RELOAD_NEEDED = gql`
  subscription {
    balanceReloadCheck {
      needed
    }
  }
`;

const withNeedBalanceReload = graphql(QUERY_BALANCE_RELOAD_NEEDED, {
  options: { fetchPolicy: 'cache-and-network' },
  props: ({ ownProps, data }) => {
    return {
      data,
      subscribeToNewData: () => {
        return data.subscribeToMore({
          document: SUBSCRIPTION_BALANCE_RELOAD_NEEDED,
          updateQuery: (prev, { subscriptionData }) => {
            const reloadNeeded = subscriptionData.data.needed;
            if (reloadNeeded !== undefined) {
              return Object.assign({}, prev, {
                balanceReloadNeeded: Object.assign(
                  {},
                  prev.balanceReloadNeeded,
                  {
                    needed: reloadNeeded
                  }
                )
              });
            }
            return null;
          }
        });
      }
    };
  }
});

GameBalanceReloader.propTypes = {
  data: PropTypes.shape({
    balanceReloadNeeded: PropTypes.shape({
      needed: PropTypes.bool
    }),
    loading: PropTypes.bool,
    error: errorShape
  })
};

export default compose(
  graphql(WheelWedgesQuery, WheelWedgesOption),
  graphql(SelectStopWedgeMutation, SelectStopWedgeOption),
  graphql(ConfirmStopWedgeMutation, ConfirmStopWedgeOption),
  withNeedBalanceReload
)(GameBalanceReloader);
